import { defineComponent as a, createBlock as s, openBlock as p, Teleport as n, createVNode as d, mergeProps as f, unref as i, withCtx as l, renderSlot as u } from "vue";
import m from "./AlertGroupInline.vue2.js";
import { useOUIAProps as c } from "../../helpers/ouia.js";
const h = /* @__PURE__ */ a({
  name: "PfAlertGroup",
  inheritAttrs: !1,
  __name: "AlertGroup",
  props: {
    toast: { type: Boolean },
    appendTo: { default: "body" }
  },
  setup(t) {
    const e = t, r = c({ id: e.ouiaId, safe: e.ouiaSafe });
    return (o, A) => (p(), s(n, {
      disabled: !o.toast,
      to: o.appendTo
    }, [
      d(m, f({ ...i(r), ...o.$attrs }, { toast: o.toast }), {
        default: l(() => [
          u(o.$slots, "default")
        ]),
        _: 3
      }, 16, ["toast"])
    ], 8, ["disabled", "to"]));
  }
});
export {
  h as default
};
